import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

const useQueryLoanDetail = (id?: string | number) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["LoanDetails", id],
    queryFn: () => fetchApi(`loanDetails?id=${id}`, token).get(),
    refetchOnWindowFocus: false,
  });
};

export default useQueryLoanDetail;
